/**
 * Removes all query parameters from the current URL
 * @param {Object} history - React Router history object
 */
export const removeQueryParamsFromUrl = (history) => {
  const url = new URL(window.location.href);
  url.search = ''; // Removes query parameters
  history.replace(url.pathname);
};

// You could also add other URL utilities here in the future
export const removeSpecificQueryParam = (history, paramName) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(paramName);
  history.replace(url.pathname + url.search);
};
